import "./styles/featurettes.scss";
import "./styles/home.scss";
